export const FLY_CABIN_CLASS = {
  BUSINESS: 'BUS',
  ECONOMY: 'ECO',
  FIRST: 'FST',
  PREMIUM_ECONOMY: 'PEC'
} as const
